import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {gsap} from "gsap";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";


export class WaysCounter extends PIXI.Container implements StageLayer {
    private _bg: PIXI.Sprite;
    private _count: PIXI.Text;
    private _waysTxt: PIXI.Text;
    private _overlay: PIXI.Sprite;


    constructor() {
        super();
        this.name = "waysCounter";
        this.init();
    }

    public hide(): void {
        this.visible = false;
    }

    public show(): void {
        this.visible = true;
    }

    onResize() {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        this.visible = true;
        if (NolimitApplication.isLandscape) {
            this.scale.set(1, 1);
            this.position.set(-200, 190);
            if (bounds.width <= 970) {
                this.visible = false;
            }
        } else {
            if (bounds.height <= 970) {
                this.visible = false;
            } else {
                this.scale.set(0.75, 0.75);
                this.position.set(55, 95);
            }

        }

    }

    public showCurrentWays(): void {
        const totalWays: number = XwaysHoarder2.model.data.totalWays;
        const countTL: gsap.core.Timeline = gsap.timeline({
            onUpdate: () => {
                let currentValue: number = parseInt(this._count.text);
                if (currentValue !== totalWays) {
                    if (totalWays - currentValue > 1) {
                        currentValue += 1;
                        this._count.text = currentValue.toString();
                    }
                }
            }, onComplete: () => {

                if(totalWays > 999999999) {
                    this._count.style = {
                        fontSize: 22,
                        fill: "#94c56f",
                        fontFamily: "OpenSansCondensedBold",
                        fontStyle: "normal",
                        fontWeight: FontWeight.NORMAL,
                        stroke: 0x1d331b,
                        strokeThickness: 2,
                        lineJoin: "round"
                    };
                }
                else if(totalWays > 9999999) {
                    this._count.style = {
                        fontSize: 28,
                        fill: "#94c56f",
                        fontFamily: "OpenSansCondensedBold",
                        fontStyle: "normal",
                        fontWeight: FontWeight.NORMAL,
                        stroke: 0x1d331b,
                        strokeThickness: 2,
                        lineJoin: "round"
                    };
                }
                else {
                    this._count.style = {
                        fontSize: 40,
                        fill: "#94c56f",
                        fontFamily: "OpenSansCondensedBold",
                        fontStyle: "normal",
                        fontWeight: FontWeight.NORMAL,
                        stroke: 0x1d331b,
                        strokeThickness: 2,
                        lineJoin: "round"
                    };
                }
                this._count.text = totalWays.toString();
            }
        });

        countTL.to(this, {duration: 0.2});
    }

    public reduceToDefault(): void {
        const defaultValue: number = 729;
        const defaultTL: gsap.core.Timeline = gsap.timeline({
            onUpdate: () => {
                let currentValue: number = parseInt(this._count.text);
                if (currentValue !== defaultValue) {
                    if (currentValue - defaultValue > 1) {
                        currentValue -= 1;
                        this._count.text = currentValue.toString();
                    }
                }
            }, onComplete: () => {
                this._count.style = {
                    fontSize: 40,
                    fill: "#94c56f",
                    fontFamily: "OpenSansCondensedBold",
                    fontStyle: "normal",
                    fontWeight: FontWeight.NORMAL,
                    stroke: 0x1d331b,
                    strokeThickness: 2,
                    lineJoin: "round"
                };
                this._count.text = defaultValue.toString();
            }
        });
        defaultTL.to(this, {duration: 0.2});
    }

    public transitionfade(alphaTo: number, dur: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this, {duration: dur, alpha: alphaTo});
        return tl;
    }

    private init(): void {
        this._bg = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures("xwaysBG")[0]);
        this._bg.name = "xwaysBG";
        this._bg.anchor.set(0.5);
        this.position.set(0, 0);

        this._count = new PIXI.Text("729", {
            fontSize: 40,
            fill: "#94c56f",
            fontFamily: "OpenSansCondensedBold",
            fontStyle: "normal",
            fontWeight: FontWeight.NORMAL,
            stroke: 0x1d331b,
            strokeThickness: 2,
            lineJoin: "round"
        });
        this._count.anchor.set(0.5);
        this._count.position.set(0, -15);
        this._count.name = "count no";

        this._waysTxt = new PIXI.Text("WAYS", {
            fontSize: 36,
            fill: "#748668",
            fontFamily: "OpenSansCondensedBold",
            fontStyle: "normal",
            fontWeight: FontWeight.NORMAL,
            lineJoin: "round"
        });
        this._waysTxt.position.set(0, 30);
        this._waysTxt.anchor.set(0.5);
        this._waysTxt.name = "waystext";

        this._overlay = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures("xwaysOverlay")[0]);
        this._overlay.name = "dirt overlay";
        this._overlay.anchor.set(0.5, 0.5);
        this._overlay.position.set(0, 0);


        this.addChild(this._bg, this._waysTxt, this._count, this._overlay);
        this.onResize();
    }
}